import React, { useState, useEffect } from 'react';

const SimpleBeforeAfter = ({ 
  before, 
  after, 
  cycleDuration = 2000,
  className = "",
  style = {} 
}) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let animationId;
    let startTime;

    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const elapsed = timestamp - startTime;
      const cycle = elapsed % cycleDuration;
      const halfDuration = cycleDuration / 2;

      // Create smooth back-and-forth motion (0 -> 1 -> 0)
      let normalizedProgress;
      if (cycle <= halfDuration) {
        normalizedProgress = cycle / halfDuration;
      } else {
        normalizedProgress = 1 - (cycle - halfDuration) / halfDuration;
      }

      setProgress(normalizedProgress);
      animationId = requestAnimationFrame(animate);
    };

    animationId = requestAnimationFrame(animate);

    return () => {
      if (animationId) {
        cancelAnimationFrame(animationId);
      }
    };
  }, [cycleDuration]);

  const containerStyle = {
    position: 'relative',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    borderRadius: '8px',
    ...style
  };

  const imageStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block'
  };

  const afterImageStyle = {
    ...imageStyle,
    clipPath: `inset(0 ${100 - (progress * 100)}% 0 0)`
  };

  const dividerStyle = {
    position: 'absolute',
    top: 0,
    left: `${progress * 100}%`,
    width: '2px',
    height: '100%',
    background: 'linear-gradient(to bottom, #666, #fff, #666)',
    transform: 'translateX(-1px)',
    boxShadow: '0 0 3px rgba(0,0,0,0.4)',
    zIndex: 10
  };

  return (
    <div style={containerStyle} className={className}>
      {/* Before image (background) */}
      <img 
        src={before} 
        alt="Before" 
        style={imageStyle}
      />
      
      {/* After image (clipped to reveal from left) */}
      <img 
        src={after} 
        alt="After" 
        style={afterImageStyle}
      />
      
      {/* Sliding divider */}
      {progress > 0 && progress < 1 && (
        <div style={dividerStyle} />
      )}
    </div>
  );
};

export default SimpleBeforeAfter;
